export default __webpack_public_path__ + "static/media/sold_mobile.13b872f5.png";